import { userUpdateFilterCriteria } from "../../../actions/user-actions"
import { autocompleteCommunitiesRequest } from "../../../actions/autocomplete-actions"

import buildItemConnector from "../../common/build-item-connector"
import UserFilterForm from "./UserFilterForm"

export default buildItemConnector(
    "users",
    true,
    userUpdateFilterCriteria,
    null,
    {
        onCommunitiesSearch: autocompleteCommunitiesRequest
    }
)(UserFilterForm)
